import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import { routerMiddleware } from "react-router-redux"
import { createBrowserHistory } from "history";
import ReduxPromise from "redux-promise"
import { loadUser } from 'redux-oidc'
import userManager from "../userManager.js"
import { reducers } from "./reducers"
import { initialstate } from './initialstate'

const history = createBrowserHistory()
const middleware = routerMiddleware(history)
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default function configureStore() {
  const store = createStore(
    reducers,
    initialstate, 
    composeEnhancer(applyMiddleware(thunk, middleware,ReduxPromise)),
  )
  loadUser(store, userManager)
  return store
}


// WEBPACK FOOTER //
// ./src/redux/store.js